<template>
  <div class="outter-modal">
    <div class="modal fade show" style="display: block; overflow: auto" tabindex="-1" @click="onClose">
      <div class="modal-dialog modal-lg modal-dialog-centered" @click.stop="">
        <div class="modal-content">
          <div class="modal-header">
            <span>Nexus Price History &mdash; Lead #{{ lead.id }}</span>
            <button type="button" class="close" aria-label="Close" @click="onClose">&times;</button>
          </div>
          <div class="modal-body">
            <p class="mb-3">
              <b>{{ lead.pickupLocation.city }}, {{ lead.pickupLocation.state }} {{ lead.pickupLocation.zip }}</b>
              &rarr;
              <b>{{ lead.deliveryLocation.city }}, {{ lead.deliveryLocation.state }} {{ lead.deliveryLocation.zip }}</b>
            </p>

            <div class="d-flex flex-wrap align-items-end mb-3">
              <div class="mr-2 mb-2">
                <label class="small mb-1">Match by</label>
                <b-select size="sm" v-model="matchMode" :options="matchModeOptions" />
              </div>
              <template v-if="matchMode === 'radius'">
              <div class="mr-2 mb-2">
                <label class="small mb-1">Pickup radius</label>
                <b-select size="sm" v-model="pickupRadius" :options="radiusOptions" />
              </div>
              <div class="mr-2 mb-2">
                <label class="small mb-1">Delivery radius</label>
                <b-select size="sm" v-model="deliveryRadius" :options="radiusOptions" />
              </div>
              </template>
              <div class="mr-2 mb-2">
                <label class="small mb-1">Period</label>
                <b-select size="sm" v-model="period" :options="periodOptions" />
              </div>
              <button type="button" class="btn btn-sm btn-primary mb-2" @click="fetchHistory">Search</button>
            </div>

            <LoadingIndicator v-if="loading" centered />
            <template v-else>
              <div v-if="stats.count" class="mb-3">
                <span class="mr-4">Matches: <b>{{ stats.count }}</b></span>
                <span class="mr-4">Median customer price: <b>{{ stats.customerPrice | formatMoney }}</b></span>
                <span class="mr-4">Median carrier pay: <b>{{ stats.carrierPay | formatMoney }}</b></span>
                <span>Median margin: <b>{{ stats.margin | formatMoney }}</b></span>
              </div>
              <b-table :items="items" :fields="fields" show-empty empty-text="No comparable Nexus shipments found." striped bordered responsive>
                <template #cell(id)="data"><router-link :to="{ name: 'OrderDetails', params: { id: data.item.id } }">#{{ data.item.id }}</router-link></template>
                <template #cell(date)="data">{{ data.item.date | formatDate }}</template>
                <template #cell(customerPrice)="data">{{ data.item.customerPrice | formatMoney }}</template>
                <template #cell(carrierPay)="data">{{ data.item.carrierPay | formatMoney }}</template>
                <template #cell(margin)="data">{{ data.item.margin | formatMoney }}</template>
              </b-table>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" />
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import LoadingIndicator from '@/components/shared/LoadingIndicator';

export default {
  name: 'LeadsCardPriceHistoryModal',
  components: { LoadingIndicator },
  props: {
    lead: { type: Object, required: true },
    onClose: { type: Function, default: () => {} },
  },
  data() {
    return {
      loading: false,
      items: [],
      stats: {},
      pickupRadius: 50,
      deliveryRadius: 50,
      period: 365,
      matchMode: 'state',
      matchModeOptions: [
        { text: 'State to state', value: 'state' },
        { text: 'Radius', value: 'radius' },
      ],
      radiusOptions: [0, 25, 50, 100].map(value => ({ text: value ? `${value} miles` : 'Exact match', value })),
      periodOptions: [
        { text: '1 Month', value: 30 }, { text: '3 Months', value: 90 },
        { text: '6 Months', value: 180 }, { text: '12 Months', value: 365 },
      ],
      fields: [
        { key: 'id', label: 'Order' }, { key: 'date', label: 'Date' }, { key: 'vehicle', label: 'Vehicle' },
        { key: 'customerPrice', label: 'Customer Price' }, { key: 'carrierPay', label: 'Carrier Pay' },
        { key: 'margin', label: 'Margin' }, { key: 'status', label: 'Status' },
      ],
    };
  },
  mounted() { this.fetchHistory(); },
  methods: {
    async fetchHistory() {
      this.loading = true;
      try {
        const response = await ApiClient.marketRates.priceHistory({ params: {
          pickupLocation: this.lead.pickupLocation.zip, deliveryLocation: this.lead.deliveryLocation.zip,
          pickupRadius: this.pickupRadius, deliveryRadius: this.deliveryRadius, period: this.period,
          matchMode: this.matchMode, routeDistance: this.lead.distance,
          excludeLeadId: this.lead.id,
        } });
        this.items = response?.data?.data || [];
        this.stats = response?.data?.stats || {};
      } finally { this.loading = false; }
    },
  },
};
</script>

<style lang="scss" scoped>
.outter-modal { position: absolute; z-index: 1089; }
</style>
